import React from "react";
import { Outlet } from "react-router-dom";

const AdminDashboardoutlet = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default AdminDashboardoutlet;
